export default {"src":"/_next/static/image/public/images/flags/flag_594.3d92b1847a8163b73bfb5ac380729aee.svg","height":16,"width":24};